<mat-button-toggle-group>
  <mat-button-toggle
    (click)="toggleEditMode()"
    [checked]="(selectedToolStore.$ | async) === 'ColorSelect'"
    [matTooltip]="toggleEditModeTooltip"
  >
    <fa-icon [icon]="icon" [fixedWidth]="true"></fa-icon>
  </mat-button-toggle>
</mat-button-toggle-group>
